import "./Key.css";

import { ColorConstants } from "../../../../../../constants";

export const Key = (): JSX.Element => {
  return (
    <div className="Key">
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_500 }} />
        <p className="body3">Completed</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.VIOLET_500 }} />
        <p className="body3">In review</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.CORAL_500 }} />
        <p className="body3">In progress</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.RED_500 }} />
        <p className="body3">Blocked</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_400 }} />
        <p className="body3">To do</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREY_100 }} />
        <p className="body3">Unassigned</p>
      </div>
    </div>
  );
};
